import crud from "./crud";
import crud_service from "@/services/crud";

const path = "verification_categories";
const struct = {
  name: '',
  name_en: '',
};
const generic = crud(path, struct);

const state = {
  ...generic.state,
};

const getters = {
  ...generic.getters,
};

const mutations = {
  ...generic.mutations,
};

const actions = {
  ...generic.actions,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
